 
import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  residueWrapper: {
    display: 'inline-block',
    width: '18px',
    textAlign: 'center',
  },
  residue: {
    width: '18px',
    height: '21px',
    '&.darkBg': {
      color: 'white',
    },
    '&.lightBg': {
      color: theme.palette.text.primary,
    },
    // Full overlap, when colors and features are not set together
    '&.lightFeatureStrippes': {
      backgroundColor: 'repeating-linear-gradient(-45deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 4px, rgba(255, 255, 255, 0.3) 3px, rgba(255, 255, 255, 0.3) 5px)',
    },
    '&.darkFeatureStrippes': {
      backgroundColor: 'repeating-linear-gradient(-45deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) 4px, rgba(0, 0, 0, 0.2) 5px, rgba(0, 0, 0, 0.2) 5px)',
    },
    '& > .thinFeatureStrippes': {
      position: 'absolute',
      width: '100%',
      height: '5px',
      bottom: '-5px',
      '&.lightBg': {
        backgroundColor: 'repeating-linear-gradient(-45deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.5) 1px, rgba(255, 255, 255, 0) 2px, rgba(255, 255, 255, 0) 4px)',
      },
      '&.darkBg': {
        backgroundColor: 'repeating-linear-gradient(-45deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) 1px, rgba(0, 0, 0, 0.2) 2px, rgba(0, 0, 0, 0.2) 3px)',
      },
    },
  },
  feature: {
    width: '18px',
    height: '4px',
  },
});
